import { API } from "config/API"

export const getCreditAccounts = async (filters) => {
  const response = await API.get("/credit-accounts", { params: filters })
  return response
}

export const editCreditAccount = async (id, payload) => {
    const response = await API.patch(`/credit-accounts/${id}`, payload)
    return response
  }

export const getCreditAccount = async (id) => {
  const response = await API.get(`/credit-accounts/${id}`)
  return response
}

export const payCreditAccount = async (id, payload) => {
  const response = await API.post(`/credit-accounts/${id}/pay`, payload)
  return response
}

export const deleteCreditAccount = async (id) => {
  const response = await API.delete(`/credit-accounts/${id}`)
  return response
}
